import React from 'react';

import ProductListSetCardActions from './components/product-list-set-card-actions/product-list-set-card-actions';
import ProductListCardDetails from '../product-list-card-details/product-list-card-details';
import ProductListCardHighlight from '../product-list-card-highlight/product-list-card-highlight';
import ProductListCardPromos from '../product-list-card-promos/product-list-card-promos';

import { useProductQuantity } from '../../../../shared/hooks/hooks';

import { getProductSet } from '../../../../shared/utils/product/product';

import {
  ProductData,
  ProductTypeEnum
} from '../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../shared/types/product';

import './product-list-set-card.scss';

interface ProductListSetCardProps {
  onAddProductClick: (productItem: ProductItem) => void;
  onCheckInventoryClick: () => void;
  onViewProductClick: () => void;
  pageNum?: number;
  product: ProductData;
}

function ProductListSetCard(props: ProductListSetCardProps) {
  const {
    onAddProductClick,
    onCheckInventoryClick,
    onViewProductClick,
    pageNum,
    product
  } = props;
  const productSet = getProductSet(product);
  const productDetailUrl = product?.url || '';
  const { productSetQuantity, setProductSetQuantity, totalQuantity } =
    useProductQuantity({
      initialSetQuantity: productSet?.map(() => 1),
      productType: ProductTypeEnum.Accessories
    });

  if (window['isPreRendering']) {
    return (
      <div data-testid="product-list-set-card--empty" styleName="container" />
    );
  }

  return (
    <div
      data-testid="product-list-set-card"
      id={product && product.code ? `product-code-${product.code}` : ''}
      styleName="container"
    >
      <ProductListCardHighlight product={product} />

      <ProductListCardDetails
        hidePrice
        hideProductCode
        hideProductSize
        onCheckInventoryClick={onCheckInventoryClick}
        onViewProductClick={onViewProductClick}
        pageNum={pageNum}
        product={productSet[0]}
        productDetailUrl={`${productDetailUrl}/set`}
        quantity={productSetQuantity[0]}
        styleName="set-card-details"
        totalQuantity={totalQuantity}
      />

      <ProductListCardPromos
        productSet={productSet}
        productSetQuantity={productSetQuantity}
      />

      <ProductListSetCardActions
        onAddProductClick={onAddProductClick}
        onQuantityChange={(quantity, index) =>
          setProductSetQuantity(quantity, index)
        }
        productSet={productSet}
        productSetQuantity={productSetQuantity}
        totalQuantity={totalQuantity}
      />
    </div>
  );
}

export default ProductListSetCard;
